import { applyEncryptToAxios } from 'axios-encrypt'
import CryptoJS from 'crypto-js'
import config, { ApiEncSec } from '../config'
import { Agent } from '../generated-api/Agent'
import { ContentType } from '../generated-api/http-client'

class AgentExtended extends Agent {
  sendSmsAgain = (body: { phone_number: string }) =>
    this.request<{ redirect?: boolean }, void>({
      path: `/agent/onboard/send-sms-again`,
      method: 'POST',
      type: ContentType.Json,
      format: 'json',
      body,
    })
}

const api = new AgentExtended({
  baseURL: config.api_url,
})

applyEncryptToAxios(api.instance, {
  onEncrypt(str: string): string {
    let encrypted = CryptoJS.DES.encrypt(str, ApiEncSec)
    return encrypted.toString()
  },
})

export default api
